import React, { useState } from "react";

function FoodForm({ onAddFood }) {
  // 食材、期限、数量のステートを定義
  const [name, setName] = useState("");
  const [expiration_date, setExpirationDate] = useState("");

  // フォーム送信時に実行
  const handleSubmit = (e) => {
    // デフォルトのフォーム送信をキャンセル
    e.preventDefault();
    const newFood = { name, expiration_date };
    onAddFood(newFood);
    // フォーム送信後に3つの入力欄を空にする
    setName("");
    setExpirationDate("");
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onInvalid={(e) => {
          e.target.setCustomValidity("食材の名が入力されておらぬぞよ");
        }}
        onInput={(e) => {
          e.target.setCustomValidity("");
        }}
        placeholder="食材名を入力せよ"
        required
      />
      <input
        type="date"
        value={expiration_date}
        onChange={(e) => setExpirationDate(e.target.value)}
        onInvalid={(e) => {
          e.target.setCustomValidity("食材の期限が入力されておらぬぞよ");
        }}
        onInput={(e) => {
          e.target.setCustomValidity("");
        }}
        placeholder="食材の期限を入力せよ"
        required
      />
      <button type="submit" className="add">
        いってらっしゃい
      </button>
    </form>
  );
}

export default FoodForm;
